module.exports = __webpack_public_path__ + "8a6b2ecd9e4fc765eb6c3f6ecd29776e.png";